import { chat } from '@utils/constants';
import React, { useEffect } from 'react';
import ChatSmooch from './ChatSmooch';
import ChatSprinklr from './ChatSprinklr';
import customEventBus from '@common/scripts/libs/eventBus';
const allowedPageCategories = ['myaccount', 'clientservice', 'cart', 'checkout'];
const allowedPageIds = ['search-show', 'product-show'];
const Chat = (props) => {
    // const [hide, setHide] = useState<boolean>(false);
    var _a;
    useEffect(() => {
        customEventBus.on('contacts:live-chat', (data) => {
            // setHide(data.hide);
            const chatElement = document.querySelector('#spr-live-chat-app');
            if (chatElement) {
                chatElement.style.display = data.hide ? 'none' : 'block';
            }
        });
    }, []);
    // if (hide) {
    //   return <></>;
    // }
    // disable chat on sandboxes because it's blocked by CORS and causes errors
    if ((window.devmode && !props.integrationid) || window.disableLiveChat) {
        return React.createElement(React.Fragment, null);
    }
    if (allowedPageCategories.includes((_a = window.datalayerdata) === null || _a === void 0 ? void 0 : _a.pageCategory) || allowedPageIds.includes(document.body.id) || props.app) {
        // allowed chat
        if (window.chatservice == chat.sprinklr) {
            return React.createElement(ChatSprinklr, { sprinklrappid: props.integrationid, user: props.user });
        }
        if (window.chatservice == chat.zendesk) {
            return React.createElement(ChatSmooch, { integrationid: props.integrationid, app: props.app });
        }
    }
    else {
        return React.createElement(React.Fragment, null);
    }
};
export default Chat;
